/**
 * 28px ghost copy icon button for the email cell — glyph swaps to a
 * success-colored check for 3s on copy, same shape as
 * OrgSettings/CustomDomainPage/CopyButton.js (not imported directly: that
 * one lives in a feature-specific page directory, not a shared location —
 * duplicated here per the project's established per-page convenience
 * component convention; promote to theme/untitled/ if a third call site
 * ever needs it).
 */
import React, { useCallback, useEffect, useState } from "react";
import classNames from "classnames";
import { copyPlainTextToClipboard } from "../../../../helpers/clipboard";
import Icon from "../../theme/untitled/icons/Icon";
import Tooltip from "../../theme/untitled/Tooltip/Tooltip";
import styles from "./UsersPage.module.scss";

const CopyEmailButton = ({ value }) => {
  const [showCopied, setShowCopied] = useState(false);

  useEffect(() => {
    if (!showCopied) {
      return undefined;
    }

    const timer = setTimeout(() => setShowCopied(false), 3000);
    return () => clearTimeout(timer);
  }, [showCopied]);

  const onClick = useCallback(
    async (e) => {
      e.preventDefault();
      await copyPlainTextToClipboard(value);
      setShowCopied(true);
    },
    [value]
  );

  return (
    <Tooltip content={showCopied ? "Copied" : "Copy email"}>
      <button
        type="button"
        className={classNames(styles.copyEmailButton, {
          [styles["is-copied"]]: showCopied,
        })}
        onClick={onClick}
        aria-label="Copy email"
      >
        <Icon name={showCopied ? "Check" : "Copy01"} size={16} />
      </button>
    </Tooltip>
  );
};

export default CopyEmailButton;
